export default {
  path: 'activate-account/:token',
  name: 'ActivateAccount',
  component: () => import(/* webpackChunkName: "ActivateAccount" */ '@/app/auth/activateAccount/ActivateAccount.vue'),
  meta: {
    title: 'TV24 | Aktywacja konta',
    public: true,
    onlyWhenLoggedOut: true,
  },
};
